/**
 * Образовательные услуги для УФТТ 3.0, краткое описание
 */
import { Identity } from '@n3/ng-api-common';
import { EntityState } from '@n3/ng-api-common';
import { ClassifierShort } from '@n3/ng-api-common';
import { BaseModel } from '@n3/ng-api-base-kit';

export class EducationServiceShort extends BaseModel {
    public _isEmpty: boolean; /*указывает на то пустой ли объект*/
    public identity: Identity; /**/
    public entity_state: EntityState; /**/
    public institution_identity: Identity; /**/
    public kind: ClassifierShort; /**/
    public name: string; /*Наименование*/
    public direction: ClassifierShort; /**/

    constructor(json?: any) {
        if (json === void 0 || json === null) {
            json = {};
        }
        super();

        this.identity = new Identity(json.identity);
        this.entity_state = new EntityState(json.entity_state);
        this.institution_identity = new Identity(json.institution_identity);
        this.kind = new ClassifierShort(json.kind);
        this.name = json.name || null;
        this.direction = new ClassifierShort(json.direction);
        this._isEmpty = this.isEmpty(this);
    }
}
